import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);
const convertDateTimeTimeZoneByDayJs = (inputDateTime, inputTimeZone, outputTimeZone, outputDateTimeFormat) => {
  let dateTime;
  if (typeof inputDateTime === "string" || typeof inputDateTime === "number") {
    dateTime = dayjs.tz(inputDateTime, inputTimeZone).tz(outputTimeZone);
  } else if (dayjs.isDayjs(inputDateTime)) {
    dateTime = inputDateTime.tz(inputTimeZone).tz(outputTimeZone);
  } else {
    throw new Error(
      "Unsupported input type for convertDateTimeTimeZoneByDayJs"
    );
  }
  return dateTime.format(outputDateTimeFormat);
};
const dateServerToClient = (inputDateTime, inputTimeZone = "Asia/Shanghai", outputDateTimeFormat = "YYYY-MM-DD HH:mm:ss") => {
  const clientTimeZone = dayjs.tz.guess();
  return convertDateTimeTimeZoneByDayJs(
    inputDateTime,
    inputTimeZone,
    clientTimeZone,
    outputDateTimeFormat
  );
};
const dateClientToServer = (inputDateTime, serverTimeZone = "Asia/Shanghai", outputDateTimeFormat = "YYYY-MM-DD HH:mm:ss") => {
  const clientTimeZone = dayjs.tz.guess();
  return convertDateTimeTimeZoneByDayJs(
    inputDateTime,
    clientTimeZone,
    serverTimeZone,
    outputDateTimeFormat
  );
};
export {
  dateClientToServer,
  dateServerToClient
};
